var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button-center',{attrs:{"caption":"習慣を登録する","action":_vm.save,"color":"blue"}})}
var staticRenderFns = []

export { render, staticRenderFns }